import { StateMessage } from '@/components/ui/controls';
import { NOT_YET } from '@/components/ui/not-yet';
import { PageHeader } from '@/components/ui/page';
import { showDemo } from '@/constants/routes';
import { MOCK_INSTAGRAM_THREADS } from '@/mocks/inbox';

import ChannelNav from './channel-nav';
import InboxPage from './inbox';

/**
 * Instagram (LEAD-6, open question Q18): direct messages to our account. A first
 * question creates a lead once the person gives an email. Preview: how Prisma
 * reads Instagram is still open. The made-up threads show only locally (showDemo).
 */
const InstagramInboxPage = () =>
  showDemo ? (
    <InboxPage
      description="Direct messages to our Instagram account. The bot asks for an email so the person becomes a lead."
      initial={MOCK_INSTAGRAM_THREADS}
      requirements={['LEAD-6', 'Q18']}
      empty="Every message has an answer. New ones appear here as they arrive."
    />
  ) : (
    <div>
      <PageHeader title="Conversations" description="Direct messages to our Instagram account.">
        <ChannelNav />
      </PageHeader>
      <StateMessage title="No data yet">{NOT_YET.instagram}</StateMessage>
    </div>
  );

export default InstagramInboxPage;
